import { stepIconClasses, StepLabel, stepLabelClasses, StepLabelProps, styled } from '@mui/material';

export const StepLabelStyled = styled((props: StepLabelProps) => <StepLabel {...props} />)(({ theme }) => ({
  [`.${stepLabelClasses.iconContainer}.${stepLabelClasses.completed}`]: {
    [`& .${stepIconClasses.root}.${stepIconClasses.completed}`]: {
      color: `${theme.palette.success.main}`,
    },
  },
}));
